module.exports = __webpack_public_path__ + "img/image.31a7fe32.png";